module.exports = __webpack_public_path__ + "static/media/operaciones.c35211a3.svg";